import numeral from 'numeral';
import { FORMATS } from '@/services/constants/format';
import type { FormatterArgs } from '@/services/types/formatter';
import { compareCellDisplay } from '@/views/formatters/compare_reports';

export default ({ data, key, decimal = 0 }: FormatterArgs) => {
  if (Array.isArray(data[key])) {
    return compareCellDisplay('', [
      numeral(data[key][0] || 0).format(FORMATS[decimal]),
      numeral(data[key][1] || 0).format(FORMATS[decimal]),
      numeral(data[key][2] || 0).format(FORMATS[decimal]),
      numeral(data[key][3] || 0).format(FORMATS[decimal]),
    ]);
  }

  return {
    kind: 'number',
    text: numeral(data[key] || 0).format(FORMATS[decimal]),
  };
};
